import {CellProps, Column, Row} from '@komune-io/g2-layout'
import {Typography} from '@mui/material'
import {TFunction} from 'i18next'
import {PlatformTableSearchFilters, PlatformPaginatedTable} from "@tracabois/template";
import {firstPage, OffsetPagination, PageQuery, PageResult} from "@tracabois/utils";
import {Commune} from "../../model/Commune";

interface CommuneTableProps {
  page?: PageResult<Commune>
  isLoading?: boolean
  onPageQueryChange: (page: PageQuery) => void;
  onRowClicked: (row: Row<Commune>) => void;
  actions: React.ReactNode
}

export const CommuneTable = (props: CommuneTableProps) => {
  const {page, isLoading, onPageQueryChange, onRowClicked, actions} = props

  const onSearch = (search?: string) => {
    onPageQueryChange({
      pagination: page?.pagination || firstPage,
      search: search
    })
  }
  const filter = (
    <PlatformTableSearchFilters actions={actions} onSubmit={(props) => onSearch(props.search)}/>
  )
  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination,
      search: page?.search
    })
  }
  return (
    <PlatformPaginatedTable<Commune>
      page={page}
      columnsDefinition={getColumns}
      isLoading={isLoading}
      actions={filter}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
      noElevation
    />
  )
}


const getColumns = (t: TFunction): Column<Commune>[] => ([{
  Header: "Nom",
  // @ts-ignore
  Cell: ({row}: CellProps<Commune>) => (
    <Typography variant="body2"
    >{row.original.name}</Typography>
  )
}, {
  Header: "Code INSEE",
  // @ts-ignore
  Cell: ({row}: CellProps<Commune>) => (
    <Typography variant="body2"
    >{row.original.codeInsee}</Typography>
  )
}, {
  Header: "Département",
  // @ts-ignore
  Cell: ({row}: CellProps<Commune>) => (
    <Typography variant="body2"
    >{row.original.department}</Typography>
  )
}])
